import { Col, Row } from '@thd-olt-component-react/core-ui';
import proptypes from 'prop-types';
const { arrayOf, shape, string } = proptypes;
import React from 'react';

export const TableView = ({ title, information }) => {
  const {
    whatInformationDoesThisInclude,
    whereDoWeCollectItFrom,
    whyDoWeCollectIt,
    whoDoWeShareItWith
  } = information;

  return (
    <Row>
      <Col className="box-shadow">
        <h4><b>{title}</b></h4>
        <Row>
          <Col md="3" sm="3" lg="3">
            <h5><b>What Information Does This Include?</b></h5>
            <Row className="content-margin-10" />
            {/* eslint-disable-next-line react/no-danger */}
            <p dangerouslySetInnerHTML={{ __html: whatInformationDoesThisInclude }} />
          </Col>
          <Col md="3" sm="3" lg="3">
            <h5><b>Where Do We Collect It From?</b></h5>
            <Row className="content-margin-10" />
            <ul>
              {whereDoWeCollectItFrom.map((msg) => {
                // eslint-disable-next-line react/no-danger
                return <li dangerouslySetInnerHTML={{ __html: msg }} />;
              })}
            </ul>
          </Col>
          <Col md="3" sm="3" lg="3">
            <h5><b>Why Do We Collect and Disclose It?</b></h5>
            <Row className="content-margin-10" />
            <ul>
              {whyDoWeCollectIt.map((msg) => {
                // eslint-disable-next-line react/no-danger
                return <li dangerouslySetInnerHTML={{ __html: msg }} />;
              })}
            </ul>
          </Col>
          <Col md="3" sm="3" lg="3">
            <h5><b>Who Do We Disclose It To?</b></h5>
            <Row className="content-margin-10" />
            <ul>
              {whoDoWeShareItWith.map((msg) => {
                // eslint-disable-next-line react/no-danger
                return <li dangerouslySetInnerHTML={{ __html: msg }} />;
              })}
            </ul>
          </Col>
        </Row>
      </Col>
      <Row className="content-margin-30" />
    </Row>
  );
};

TableView.propTypes = {
  title: string.isRequired,
  information: shape({
    whatInformationDoesThisInclude: string.isRequired,
    whereDoWeCollectItFrom: arrayOf(string).isRequired,
    whyDoWeCollectIt: arrayOf(string).isRequired,
    whoDoWeShareItWith: arrayOf(string).isRequired
  }).isRequired
};
